/**
 * Umami event tracking utility.
 * Wraps umami.track() with safe fallback when tracker isn't loaded.
 *
 * Revenue events use Umami's built-in revenue tracking:
 *   umami.track('checkout-complete', { revenue: { currency: 'USD', amount: 1500 } })
 */

function track(eventName, data) {
  try {
    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track(eventName, data);
    }
  } catch {
    // Non-fatal — analytics should never break the app
  }
}

// ── Conversion Funnel ────────────────────────────────

export const trackSignup = (method) =>
  track('signup', { method }); // method: 'email' | 'google'

export const trackLogin = (method) =>
  track('login', { method });

export const trackCheckoutStarted = (tier) =>
  track('checkout-started', { tier }); // tier: 'monthly' | 'annual' | 'naplex_crunch'

export const trackCheckoutComplete = (tier, amountCents) =>
  track('checkout-complete', {
    tier,
    revenue: amountCents / 100, // Umami expects dollars, not cents
    currency: 'USD',
  });

export const trackSubscriptionCanceled = () =>
  track('subscription-canceled');

// ── Core Engagement ──────────────────────────────────

export const trackDeckUpload = (slideCount) =>
  track('deck-upload', { slides: slideCount });

export const trackBossFightStart = (bossName, tier) =>
  track('boss-fight-start', { boss: bossName, tier });

export const trackBossFightEnd = (bossName, result) =>
  track('boss-fight-end', { boss: bossName, result }); // result: 'won' | 'lost' | 'forfeited'

export const trackQuizGenerate = (questionCount) =>
  track('quiz-generate', { questions: questionCount });

export const trackExamCreate = (deckCount) =>
  track('exam-create', { decks: deckCount });

export const trackNaplexArea = (areaKey, action) =>
  track('naplex-area', { area: areaKey, action }); // action: 'gauntlet' | 'boss' | 'learning-map'

// ── Feature Discovery ────────────────────────────────

export const trackFeatureUse = (feature) =>
  track('feature-use', { feature });
// features: 'concept-card', 'drug-card', 'chat', 'pvp', 'equipment', 'train'
